import { EEntityScope } from "@/types/common/entityApproval/EntityApproval";

export interface IScopeFields {
  viewScope: EEntityScope;
  editScope: EEntityScope;
  viewDirectorateIds: string[];
  editDirectorateIds: string[];
  coordinatorId: string | null;
}

export const defaultScopeFields = (): IScopeFields => ({
  viewScope: EEntityScope.UNIT,
  editScope: EEntityScope.PRIVATE,
  viewDirectorateIds: [],
  editDirectorateIds: [],
  coordinatorId: null,
});
